import tinycolor from 'tinycolor2';

export const invertColor = (hex, grayscaleOutput = false) => {
    if (hex.indexOf('#') === 0) {
        hex = hex.slice(1);
    }
    // convert 3-digit hex to 6-digits.
    if (hex.length === 3) {
        hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
    }
    if (hex.length !== 6) {
        throw new Error('Invalid HEX color.');
    }
    let r = parseInt(hex.slice(0, 2), 16),
        g = parseInt(hex.slice(2, 4), 16),
        b = parseInt(hex.slice(4, 6), 16);
    if (grayscaleOutput) {
        // https://stackoverflow.com/a/3943023/112731
        return r * 0.299 + g * 0.587 + b * 0.114 > 186 ? '#000000' : '#FFFFFF';
    }
    // invert color components
    r = (255 - r).toString(16);
    g = (255 - g).toString(16);
    b = (255 - b).toString(16);
    // pad each with zeros and return
    const resultColor = '#' + padZero(r) + padZero(g) + padZero(b);
    return resultColor;
};

export const setTextBrightness = (hex) => {
    return invertColor(hex, true);
};

export const createTagStyle = (color) => {
    const styles = {
        backgroundColor: color,
        borderColor: setTextBrightness(color),
        color: setTextBrightness(color),
    };

    return `color: ${styles.color}; background-color: ${styles.backgroundColor}; border-color: ${styles.borderColor};`;
};

export const padZero = (str, len = 2) => {
    const zeros = new Array(len).join('0');
    return `${zeros}${str}`.slice(-len);
};

export const getDefaultColor = () => {
    return tinycolor('#000000').toHexString();
};

export const getDefaultBgColor = () => {
    return tinycolor('#FFFFFF').toHexString();
};

export const validateHexColor = (color) => {
    return /^#[0-9A-F]{6}[0-9a-f]{0,2}$/i.test(color);
};

export const useColor = () => {
    return {
        invertColor: invertColor,
        setTextBrightness: setTextBrightness,
        createTagStyle: createTagStyle,
        getDefaultColor: getDefaultColor,
        getDefaultBgColor: getDefaultBgColor,
        validateHexColor: validateHexColor,
    };
};

export default useColor;
